export const ProfileMap = {
    RESET_PASSWORD_START: 'RESET_PASSWORD_START',
    RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_ERROR: 'RESET_PASSWORD_ERROR',

    GET_PROFILE_DASHBOARD_START: 'GET_PROFILE_DASHBOARD_START',
    GET_PROFILE_DASHBOARD_SUCCESS: 'GET_PROFILE_DASHBOARD_SUCCESS',
    GET_PROFILE_DASHBOARD_ERROR: 'GET_PROFILE_DASHBOARD_ERROR',
    KYCUPDATED: 'KYCUPDATED',
}

export const ProfileActions = {
    resetPasswordStart: (data) => ({ type: ProfileMap.RESET_PASSWORD_START, payload: data }),
    resetPasswordSuccess: (data) => ({ type: ProfileMap.RESET_PASSWORD_SUCCESS, payload: data }),
    resetPasswordError: (errors) => ({ type: ProfileMap.RESET_PASSWORD_ERROR, payload: { errors } }),

    getProfileDashboardStart: (data) => ({ type: ProfileMap.GET_PROFILE_DASHBOARD_START, payload: data }),
    getProfileDashboardSuccess: (data) => ({ type: ProfileMap.GET_PROFILE_DASHBOARD_SUCCESS, payload: data }),
    getProfileDashboardError: (errors) => ({ type: ProfileMap.GET_PROFILE_DASHBOARD_ERROR, payload: { errors } }),

    kycUpdated: (data) => ({ type: ProfileMap.KYCUPDATED, payload: data }),
}